export const getPageButtons = (page: number, totalPages: number) => {
  const pageButtons: Array<number> = []
  const pageButtonCount = Math.min(totalPages, 5)
  const start = Math.min(Math.max(0, page - 2), totalPages - pageButtonCount)
  for (let i = start; i < start + pageButtonCount; i++) {
    pageButtons.push(i)
  }
  return pageButtons
}
